import type { SocialWorkspaceOpenTab } from "../studioContracts";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/** A request to open the studio on a tab, from the assistant or a notification. */
export function isSocialWorkspaceOpenTab(value: unknown): value is SocialWorkspaceOpenTab {
  return isRecord(value)
    && value.tab === "conversations"
    && typeof value.requestId === "string"
    && value.requestId.length > 0
    && value.requestId.length <= 128
    && (value.scan === undefined || typeof value.scan === "boolean");
}

/**
 * The `extraFields` a notification carries to open the studio on
 * Conversations. The server writes it and the notification row reads it, so
 * both sides share one shape.
 */
export const SOCIAL_CONVERSATIONS_NOTIFICATION_FIELDS = {
  componentName: "SocialWorkspace",
  socialWorkspaceTab: "conversations",
} as const;

/** True when a notification's `extraFields` open the studio on Conversations. */
export function opensSocialConversations(extraFields: unknown): boolean {
  return isRecord(extraFields)
    && extraFields.componentName === SOCIAL_CONVERSATIONS_NOTIFICATION_FIELDS.componentName
    && extraFields.socialWorkspaceTab === SOCIAL_CONVERSATIONS_NOTIFICATION_FIELDS.socialWorkspaceTab;
}
